/**
 * Phone number utility functions for UnifiedParsingModal
 */

/**
 * Normalize phone number (similar to QuickPhoneExtractor.normalize_phone)
 */
export const normalizePhone = (phone: string): string => {
  // Remove everything except digits and +
  let cleaned = phone.replace(/[^0-9+]/g, '')

  // Remove +
  if (cleaned.startsWith('+')) {
    cleaned = cleaned.slice(1)
  }

  // Convert 8 to 7 for Russian numbers
  if (cleaned.startsWith('8') && cleaned.length === 11) {
    cleaned = '7' + cleaned.slice(1)
  }

  // Validate length (10-15 digits)
  if (cleaned.length >= 10 && cleaned.length <= 15) {
    return cleaned
  }

  return phone // Return original if invalid
}

/**
 * Format phone number for display
 */
export const formatPhoneForDisplay = (phone: string): string => {
  const normalized = normalizePhone(phone)

  // Format Russian phone numbers
  if (normalized.length === 11 && normalized.startsWith('7')) {
    return `+7 (${normalized.slice(1, 4)}) ${normalized.slice(4, 7)}-${normalized.slice(7, 9)}-${normalized.slice(9, 11)}`
  }

  return phone
}
